module.exports = __webpack_public_path__ + "media/src/images/icons/camera_alt-white-daa51b25124e5b72b571e32874f7e3e0.svg";